import { yupResolver } from "@hookform/resolvers/yup";
import React from "react";
import { useForm } from "react-hook-form";
import { SdsForm } from "soft_digi";
import { SdsFormElementProps } from "soft_digi/dist/sdforms/SdsFromInterFace";
import * as Yup from "yup";
import { SALARY_COMPONENT_URLS } from "../../api/SettingsUrls";
import { useSiteContext } from "../../contexts/SiteProvider";
import { showAlertAutoClose } from "../../services/notifyService";
import { post } from "../../services/smartApiService";

interface HeaderProps {
  loadTableData: () => void;
  data: any;
}

const schema = Yup.object({
  component_name: Yup.string().required("Required"),
  short_name: Yup.string().required("Required"),

  component_type: Yup.object().required("Required"),

  calculation_type: Yup.object().required("Required"),

  default_amount: Yup.number()
    .required("Required")
    .positive("Default Amount must be a positive number")
    .typeError("Default Amount must be a number"),
});

const SalaryComponentsForm: React.FC<HeaderProps> = ({
  loadTableData,
  data,
}) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: data,
  });
  const { closeModal } = useSiteContext();

  const onSubmit = (formData: any) => {
    let url = SALARY_COMPONENT_URLS.INSERT;
    if (formData.ID !== undefined) {
      formData["id"] = formData.ID;
      url = SALARY_COMPONENT_URLS.UPDATE;
    }

    const subscription = post(url, formData).subscribe((response) => {
      showAlertAutoClose("Data Saved Successfully", "success");
      closeModal();
      loadTableData();
    });
    return () => subscription.unsubscribe();
  };

  const elements: SdsFormElementProps[] = [
    {
      type: "TEXT_BOX",
      width: 6,
      name: "component_name",
      element: {
        label: "Component Name",
        isRequired: true,
      },
    },
    {
      type: "TEXT_BOX",
      width: 6,
      name: "short_name",
      element: {
        label: "Component Short Name",
        isRequired: true,
      },
    },
    {
      type: "SELECT_BOX",
      width: 6,
      name: "component_type",
      element: {
        label: "Type",
        options: [
          { value: 1, label: "Basic" },
          { value: 2, label: "Allowance" },
          { value: 3, label: "Deduction" },
        ],
        isRequired: true,
      },
    },
    {
      type: "SELECT_BOX",
      width: 6,
      name: "calculation_type",
      element: {
        label: "Calculation Type",
        options: [
          { value: 1, label: "Fixed" },
          { value: 2, label: "Percentage on Basic" },
        ],
        isRequired: true,
      },
    },
    {
      type: "TEXT_BOX",
      width: 6,
      name: "default_amount",
      element: {
        label: "Default Amount",
        isRequired: true,
      },
    },

    {
      type: "BUTTON",
      width: 12,
      name: "submit_button",
      class_name: "has-text-right",
      element: {
        classList: ["button", "smart-action-button"],
        label: data.ID ? "Update" : "Add",
        onClick: handleSubmit(onSubmit),
      },
    },
  ];

  return (
    <div className="sd-hims-input">
      <SdsForm elements={elements} errors={errors} control={control} />
    </div>
  );
};

export default SalaryComponentsForm;
